var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "vx-timeline" },
    _vm._l(_vm.data, function(item, index) {
      return _c("li", { key: "destination_" + index }, [
        _c(
          "div",
          { staticClass: "timeline-icon", class: "bg-" + item.color },
          [
            _c("feather-icon", {
              attrs: {
                icon: item.icon,
                svgClasses: "text-white stroke-current w-5 h-5"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "timeline-info" }, [
          _c("h4", { staticClass: "font-bold" }, [_vm._v(_vm._s(item.title))]),
          _vm._v(" "),
          _c("span", { staticClass: "activity-desc" }, [
            _vm._v(_vm._s(item.desc))
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "activity-desc" }, [
            _vm._v(_vm._s(item.desc_2))
          ])
        ]),
        _vm._v(" "),
        _c("small", { staticClass: "text-grey activity-e-time" }, [
          _vm._v(_vm._s(item.time))
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }